import { features } from "@/mocks/kanliao";

export default function Features() {
  return (
    <section id="features" className="container-px py-16 md:py-24">
      <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
        <span className="section-title">核心能力</span>
        <h2 className="heading mt-4">为「不错过更新」而生</h2>
        <p className="prose-p mt-4">
          看料把订阅、推送与更新提醒整合成一站式体验，让每一次新料动态都能被及时捕捉、
          主动送达，把等待刷新的时间还给你。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((item) => (
          <article
            key={item.title}
            className="group rounded-2xl border border-background-200/80 bg-background-50 p-6 transition-colors hover:border-primary-300"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
                {item.tag}
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
              {item.title}
            </h3>
            <p className="mt-3 text-sm leading-7 text-foreground-600">
              {item.desc}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}